import QRCode from 'qrcode'

/**
 * QR generation, replacing ZXing.Net's BarcodeWriter.
 *
 * The original asked for 200x200 with `NoPadding`, which made the real size
 * version-dependent and, at 200px, tall enough to clip off the bottom of the
 * full-print canvas. Here the requested size is honoured exactly and the quiet
 * zone is kept at the smallest value that still scans reliably (margin 1),
 * because a QR with no quiet zone at all is measurably worse on phone cameras
 * held at an angle over glossy paper.
 */
export async function renderQr(text: string, size = 200): Promise<Blob> {
  const dataUrl = await QRCode.toDataURL(text, {
    width: size,
    margin: 1,
    errorCorrectionLevel: 'M',
    color: { dark: '#000000ff', light: '#ffffffff' },
  })
  return (await fetch(dataUrl)).blob()
}

export function renderQrDataUrl(text: string, size = 450): Promise<string> {
  return QRCode.toDataURL(text, {
    width: size,
    margin: 1,
    errorCorrectionLevel: 'M',
    color: { dark: '#000000ff', light: '#ffffffff' },
  })
}
